import { useState } from "preact/hooks";
import {
  GET,
  GET_DELIVERY_OPTION,
  GET_MAINTAIN_DEVICE_STATUS_OPTION,
  GET_MAINTENANCES,
  GET_MAINTENANCES_DETAIL,
  GET_MAINTENANCES_IMAGES,
  GET_MAINTENANCES_LINES,
  GET_SERVICE_OPTION,
  GET_SPARE_PART_OPTION,
} from "../../../services";
import { useMessage } from "../../../hooks/useMessage";
import {
  IBodyService,
  IBodySparePart,
  IStateMaintenances,
} from "../interface/statemaintenances";
import { convertDateTimeThailand } from "../../../functions";
import { IReponse } from "../../../services/interface";
import { IUseGetService, IUseGetSparePart } from "../interface";

export const useGet = () => {
  const [options, setOptions] = useState([]);
  const [optionsService, setOptionsService] = useState([]);
  const [optionsSpar, setOptionsSpar] = useState([]);
  const [stateMaintenances, setStateMaintenances] = useState(
    [] as IStateMaintenances[]
  );
  const [stateMaintenancesImage, setStateMaintenancesImage] = useState([]);
  const [stateMaintenancesLine, setStateMaintenancesLine] = useState(null);
  const [optionsDelivery, setOptionsDelivery] = useState([]);
  const { openMessage } = useMessage();

  const useGetMaintainDeviceStatusOption = async () => {
    try {
      const res: IReponse = await GET(GET_MAINTAIN_DEVICE_STATUS_OPTION);
      const { options: opt } = res.result;
      setOptions(opt);
    } catch (error) {
      console.log(error);
    }
  };

  const useGetServiceOptions = async () => {
    try {
      const res: IReponse = await GET(GET_SERVICE_OPTION);
      const { options: optsv } = res.result;
      setOptionsService(
        optsv.map((e: IBodyService) => ({ ...e, qty: 1, price: `${e.price}` }))
      );
    } catch (error) {
      console.log(error);
    }
  };

  const useGetSparePartOptions = async () => {
    try {
      const res: IReponse = await GET(GET_SPARE_PART_OPTION);
      const { options: optsp } = res.result;
      setOptionsSpar(
        optsp.map((e: IBodySparePart) => ({
          ...e,
          qty: 1,
          price: `${e.price}`,
        }))
      );
    } catch (error) {
      console.log(error);
    }
  };

  const useGetDeliveryOption = async () => {
    try {
      const res: IReponse = await GET(GET_DELIVERY_OPTION);
      const { options: optd } = res.result;
      setOptionsDelivery(optd);
    } catch (error) {
      console.log(error);
    }
  };

  const useGetMaintenances = async () => {
    try {
      const res: IReponse = await GET(GET_MAINTENANCES);
      const { maintenances } = res.result;
      const newData: IStateMaintenances[] = maintenances.map(
        (e: IStateMaintenances, i: number) => ({
          ...e,
          index: i + 1,
          createDate: convertDateTimeThailand(e.createDate),
          repairCompleteDate: convertDateTimeThailand(e.repairCompleteDate),
          trackingDate: convertDateTimeThailand(e.trackingDate),
        })
      );
      setStateMaintenances(newData);
    } catch (error) {
      console.log(error);
    }
  };

  const useGetMaintenancesImages = async (maintainId: string) => {
    try {
      const res: IReponse = await GET(
        `${GET_MAINTENANCES_IMAGES}?maintainId=${maintainId}`
      );
      const { images } = res.result;
      setStateMaintenancesImage(images);
    } catch (error) {
      console.log(error);
    }
  };

  const useGetMaintenancesLine = async (maintainId: string) => {
    try {
      const [res, res2] = await Promise.all([
        GET(`${GET_MAINTENANCES_LINES}?maintainId=${maintainId}`),
        GET(GET_MAINTENANCES_DETAIL(maintainId)),
      ]);

      const { spares, services, deliveryProduct, cause, video } = res.result;
      const { waitingMCClosed, waitingPDWork } = res2.result;

      setStateMaintenancesLine({
        ...res.result,
        linkVideo: video?.linkVideo,
        spares: spares.map((e: IUseGetSparePart) => e.sparePartName),
        services: services.map((e: IUseGetService) => e.serviceName),
        main_endjob_tracking: deliveryProduct?.trackingNo,
        main_endjob_delivery: deliveryProduct?.deliveryChannel,
        main_endjob_damage: cause?.cause,
        main_endjob_remark: cause?.remark,
        main_endjob_name_tech: waitingMCClosed?.userName,
        main_endjob_tech_start_repair_date: waitingMCClosed
          ? convertDateTimeThailand(waitingMCClosed.createDate)
          : null,
        main_endjob_tech_end_repair_date: waitingPDWork
          ? convertDateTimeThailand(waitingPDWork.createDate)
          : null,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const onSearch = async (queryString: string) => {
    try {
      const res: IReponse = await GET(`${GET_MAINTENANCES}?${queryString}`);
      const { maintenances } = res.result;
      const newData: IStateMaintenances[] = maintenances.map(
        (e: IStateMaintenances, i: number) => ({
          ...e,
          index: i + 1,
          createDate: convertDateTimeThailand(e.createDate),
        })
      );
      if (newData.length > 0) {
        setStateMaintenances(newData);
        openMessage("success", "โหลดข้อมูลเสร็จสิ้น");
      }
      if (newData.length === 0) {
        setStateMaintenances(newData);
        openMessage("error", "ไม่พบข้อมูล");
      }
    } catch (error: any) {
      openMessage("error", error.message);
    }
  };

  return {
    useGetMaintainDeviceStatusOption,
    options,
    useGetMaintenances,
    onSearch,
    stateMaintenances,
    useGetMaintenancesImages,
    stateMaintenancesImage,
    setStateMaintenancesImage,
    useGetMaintenancesLine,
    stateMaintenancesLine,
    useGetServiceOptions,
    useGetSparePartOptions,
    optionsService,
    setOptionsService,
    optionsSpar,
    setOptionsSpar,
    setStateMaintenances,
    useGetDeliveryOption,
    optionsDelivery,
  };
};
